import { useQueryClient } from '@tanstack/react-query';
import { notification } from 'antd';
import { userLogout } from 'queries/auth/user';
import React, { useEffect, useRef } from 'react';
import urls from 'routes/urls';
import { clearAuthSession } from 'utils/auth';
import websocketService from 'services/webSocket/websocketService';

export default () => {
  const queryClient = useQueryClient();
  const [api, contextHolder] = notification.useNotification();
  const isLoggingOut = useRef<boolean>(false);

  const {
    loadLogoutUser,
    isLogoutUserError,
    isLogoutUserSuccess,
    mutate: requestLogout,
    clearData: clearLogoutRequest,
  } = userLogout();

  const performLogout = () => {
    if (isLoggingOut.current) return;
    isLoggingOut.current = true;

    const wasSuperAdmin = localStorage.getItem('isSuperAdmin') === 'true';

    try {
      websocketService.close();
    } catch (e) {
      console.error('Error closing websocket on logout:', e);
    }

    clearAuthSession();
    clearLogoutRequest();
    queryClient.clear();

    // Redirect using window.location.href to force a full browser reload and clear in-memory state
    window.location.href = wasSuperAdmin ? urls.superAdminLogin : urls.login;
  };

  const onHandleLogout = () => {
    try {
      requestLogout(
        {},
        {
          onSuccess: () => performLogout(),
          onError: () => performLogout(),
        }
      );
    } catch (e) {
      performLogout();
    }

    // Safety fallback: force logout after 600ms if server is slow or unresponsive
    setTimeout(() => {
      performLogout();
    }, 600);
  };

  useEffect(() => {
    if (isLogoutUserSuccess || isLogoutUserError) {
      performLogout();
    }
  }, [isLogoutUserSuccess, isLogoutUserError]);

  return {
    contextHolder,
    onHandleLogout,
    loadLogoutUser,
  };
};

